import axios from 'axios';

// Falls back to a same-origin relative path, not a hardcoded host: frontend
// and backend are served from the same origin in production, so '/api'
// always resolves correctly there even if REACT_APP_API_URL is unset (as
// happened when frontend/.env.production was missing on the server and the
// old localhost:5009 fallback got baked into the production bundle, sending
// every visitor's browser to their own localhost instead of the real API).
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000
});

export const getDestinations = (params) => api.get('/destinations', { params }).then((r) => r.data.data);
export const getDestination = (slug) => api.get(`/destinations/${slug}`).then((r) => r.data.data);
export const getPackages = (params) => api.get('/packages', { params }).then((r) => r.data.data);
export const getPackage = (slug) => api.get(`/packages/${slug}`).then((r) => r.data.data);
export const getTestimonials = (params) => api.get('/testimonials', { params }).then((r) => r.data.data);
export const getGallery = () => api.get('/gallery').then((r) => r.data.data);
export const submitEnquiry = (payload) => api.post('/enquiries', payload).then((r) => r.data);

export default api;
